module.exports = __webpack_public_path__ + "assets/img/book@1,5x.ac42f1de.svg";